import { createSlice, createAsyncThunk, AsyncThunk } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterOrderInPerson: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "orderinperson",
  async (body: any) => {

    const data = await filterTableDataAPI(
      filterUrls.hubPickupGrid,
      // filterUrls.postLabelStick,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    );
    return data.data.payload;
  }
);

const initialState: any = {
  orderInPerson: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const OrderInPersonSlice = createSlice({
  initialState: initialState,
  name: "orderinperson",
  reducers: {
    clearOrderInPerson: (state) => {
      state.orderInPerson = [];
    },
    setFilterOrderInPerson: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterOrderInPerson.fulfilled as any]: (state, action) => {
      state.orderInPerson = action.payload;
      state.fetchPost = false;
    },
    [filterOrderInPerson.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterOrderInPerson.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterOrderInPerson, clearOrderInPerson } = OrderInPersonSlice.actions;
export default OrderInPersonSlice.reducer;
